import CustomReactSelect from "./custom-react-select.component";

export default CustomReactSelect;
